import store from "@/state/store";

export default [
  {
    path: "/",
    name: "splash",
    component: () => import("../views/splash.vue"),
  },

  /**
   * TABLET VIEWS
   */
  {
    path: "/tablet/",
    name: "tablet",
    redirect: '/tablet/login'
  },
  {
    path: "/tablet/login",
    name: "tablet-login",
    component: () => import("../views/tablet/account/login-tablet"),
    meta: {
      beforeResolve (routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "dashboard" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/tablet/logout",
    name: "tablet-logout",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "rpo"],
      beforeResolve (routeTo, routeFrom, next) {
        store.dispatch("auth/logout");
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/tablet/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? { name: "tablet-login" }
            : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/tablet/dashboard",
    name: "tablet-dashboard",
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/tablet/dashboard/dashboard.vue"),
  },
  {
    path: "/tablet/raise-incident",
    name: "tablet-raise-incident",
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/tablet/dashboard/raise-incident.vue"),
  },
  {
    path: "/tablet/incident/:incidentId",
    name: "tablet-incident",
    props: true,
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/tablet/dashboard/incident-details.vue"),
  },
  {
    path: "/tablet/report/:incidentId",
    name: "tablet-report",
    props: true,
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/tablet/dashboard/report-incident.vue"),
  },
  {
    path: "/tablet/emergency",
    name: "tablet-emergency",
    props: true,
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/tablet/dashboard/emergency-services.vue"),
  },
  {
    path: "/tablet/device",
    name: "tablet-device",
    props: true,
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/tablet/dashboard/device.vue"),
  },
  {
    path: "/tablet/incidents",
    name: "tablet-incidents",
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () =>
      import("../views/tablet/dashboard/all-incidents-table.vue"),
  },

  /**
   * MOBILE VIEWS
   */
  {
    path: "/phone/",
    name: "phone",
    redirect: '/phone/login'
  },
  {
    path: "/phone/login",
    name: "phone-login",
    component: () => import("../views/phone/account/login"),
    meta: {
      beforeResolve (routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "phone-dashboard" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/phone/logout",
    name: "phone-logout",
    meta: {
      authRequired: true,
      rolesAllowed: ["superadmin", "admin", "rpo"],
      beforeResolve (routeTo, routeFrom, next) {
        store.dispatch("auth/logout");
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/phone/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? { name: "phone-login" }
            : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/phone/dashboard",
    name: "phone-dashboard",
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/phone/dashboard/dashboard.vue"),
  },
  {
    path: "/phone/raise-incident",
    name: "phone-raise-incident",
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/phone/dashboard/raise-incident.vue"),
  },
  {
    path: "/phone/incident/:incidentId",
    name: "phone-incident",
    props: true,
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/phone/dashboard/incident-details.vue"),
  },
  {
    path: "/phone/report/:incidentId",
    name: "phone-report",
    props: true,
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/phone/dashboard/report-incident.vue"),
  },

  {
    path: "/phone/incident-report",
    name: "phone-incident-report",
    props: true,
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () =>
      import("../views/phone/dashboard/report-incident-page.vue"),
  },

  {
    path: "/phone/incident-details",
    name: "phone-incident-details",
    props: true,
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/phone/dashboard/view-incident-page.vue"),
  },

  {
    path: "/phone/emergency",
    name: "phone-emergency",
    props: true,
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/phone/dashboard/emergency-services.vue"),
  },
  {
    path: "/phone/device",
    name: "phone-device",
    props: true,
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/phone/dashboard/device.vue"),
  },
  {
    path: "/phone/incidents",
    name: "phone-incidents",
    meta: {
      authRequired: true,
      rolesAllowed: ["rpo"],
    },
    component: () => import("../views/phone/dashboard/all-incidents-table.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: require("../views/utility/404").default,
  },
  {
    path: "*",
    redirect: "404",
  },
];
